import { render } from "./VehicleManagement.vue?vue&type=template&id=25a5f8c4&scoped=true"
import script from "./VehicleManagement.vue?vue&type=script&lang=js"
export * from "./VehicleManagement.vue?vue&type=script&lang=js"

import "./VehicleManagement.vue?vue&type=style&index=0&id=25a5f8c4&scoped=true&lang=css"
import "./VehicleManagement.vue?vue&type=style&index=1&id=25a5f8c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a5f8c4"]])

export default __exports__